// Canonical country list for delivery/billing address dropdowns.
export const COUNTRIES = [
  'United Kingdom',
  'Ireland',
  'France',
  'Germany',
  'Netherlands',
  'Belgium',
  'Italy',
  'Spain',
  'Portugal',
  'Switzerland',
  'Austria',
  'Sweden',
  'Norway',
  'Denmark',
  'Finland',
  'Poland',
  'Greece',
  'United States',
  'Canada',
  'India',
  'United Arab Emirates',
  'Australia',
  'Other',
];
